var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrarBotaoProtecao)?_c('span',[_c('button',{class:_vm.classe,attrs:{"type":"button","disabled":_vm.telaBloqueada,"title":_vm.telaBloqueada
        ? 'Tela bloqueada'
        : _vm.dadosMascarados
        ? 'Dados protegidos. Clique para exibir.'
        : 'Clique para proteger os dados da tela.'},on:{"click":_vm.togglePresentation}},[_c('i',{class:_vm.dadosMascarados ? 'fas fa-eye-slash' : 'fas fa-eye'}),_vm._v(" "+_vm._s(_vm.dadosMascarados ? "Exibir dados" : "Proteger dados")+" ")]),_c('modal-verificacao-acao',{ref:"verificacaoAcao"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }